import { get, post, patch, del } from "../common/apiClient";

export function fetchLearningPaths({ page = 1, limit = 10, status } = {}) {
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("limit", String(limit));
    if (status && status !== "all") params.append("status", status);
    return get(`/learning-paths?${params.toString()}`);
}

export function fetchLearningPathById(id) {
    return get(`/learning-paths/${encodeURIComponent(id)}`);
}

export function createLearningPath(data) {
    return post("/learning-paths", data);
}

export function updateLearningPath(id, data) {
    return patch(`/learning-paths/${encodeURIComponent(id)}`, data);
}

export function markDayCompleted(pathId, dayNumber) {
    return patch(`/learning-paths/${encodeURIComponent(pathId)}/day/${dayNumber}`, {});
}

export function deleteLearningPath(id) {
    return del(`/learning-paths/${encodeURIComponent(id)}`);
}
